import React, {Component, useRef} from 'react'
//redux
import { connect } from "react-redux";
import { getUserInfoData } from "../User/store/actionCreators";
import { GET_USER_INFO_DATA } from "../User/store/actionTypes";
//样式
import {
    WagesCheckContainer
} from "./style";

//antd
import { Button, SearchBar, Space,Toast,InfiniteScroll,Empty } from 'antd-mobile';
import { PullToRefresh } from 'antd-mobile-v2';
import { List,Card } from 'antd';

import $axios from "../../request";
import ImgVideoListItem from "../../components/ImgVideoListItem";
import {isBlank} from "../../util/StringUtil";



class WagesHome extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sortTypeEnum:{default: 'sortNo',vote: 'likeNum',time: 'createDate',},
            sortType:"sortNo",
            loading: true,
            dataSource:[],
            page:1,
            limit:10,
            refreshing: false,
            hasMore:true,
            height: document.documentElement.clientHeight,
            listIndex: 0,
            oldSearchKey: "",
            newSearchKey: "",
            activity:{},
            haveActivity:false,
            totalCount:0
        }
    }

    componentDidMount() {
        const {userInfo} = this.props;
        if(userInfo===null||userInfo===undefined){
            this.props._getUserInfoData();
        }
       this.getCreationsData();
        //console.log("WagesHome")
    }

    componentWillReceiveProps(nextProps,nextContext) {
        //console.log('home UNSAFE_componentWillReceiveProps:',nextProps);

        const activity = nextProps.activity;
        if(activity!=null){
            this.setState({
                    haveActivity: true,
                    activity},
                () => this.getCreationsData());

        }else {
            console.log('home activity is null');
        }
    }

    getCreationsData =  () =>{
        //dataSource
        const {refreshing,oldSearchKey,newSearchKey} = this.state;


        const {activity} = this.props;
        if((!activity)||(isBlank(activity.id))||refreshing){
            console.log("无活动")
            return
        }else {
            this.setState({'refreshing':true})
            let page = this.state.page
            let limit = this.state.limit
            let dataSource = this.state.dataSource

            let url= "/vote/creation/list";
            let data = {
                activityId:activity.id,
                showFlag: 1,
                page: page,
                limit: limit,
                sortType: this.state.sortType,
                searchKey: newSearchKey
            }
            //console.log("list参数",data)
            $axios.postRequest(url, data).then(res => {
                    if(res && res.succeed){
                        let loading = false;
                        if(res.data.length===0){
                            this.setState({
                                loading: loading,
                                refreshing: false,
                                hasMore:false,

                            });
                        }else{
                            dataSource = page===1?res.data: dataSource.concat(res.data);
                            this.setState({
                                page: this.state.page + 1,
                                dataSource:dataSource,
                                loading: loading,
                                refreshing: false,
                                hasMore:res.totalCount>dataSource.length,
                                totalCount:res.totalCount

                            });
                        }

                    }
                }

            );
        }

    }

    initSearchData = () =>{
        const {oldSearchKey,newSearchKey} = this.state;
        const {activity} = this.props;
        if((!activity)||(isBlank(activity.id))){
            console.log("无活动")
            return
        }
        let page = this.state.page
        let limit = this.state.limit
        let dataSource = this.state.dataSource
        //清空搜索字段 重置首页
        if(newSearchKey != oldSearchKey){
            page=1
            dataSource = []
        }
        if(newSearchKey===oldSearchKey){
            return;
        }
        let url= "/vote/creation/list";
        let data = {
            activityId:activity.id,
            showFlag: 1,
            page: page,
            limit: limit,
            sortType: this.state.sortType,
            searchKey: newSearchKey
        }
        $axios.postRequest(url, data).then(res => {
                if(res && res.succeed){
                    let loading = false;
                    this.setState({
                        page: page + 1,
                        dataSource: dataSource.concat(res.data),
                        loading: loading,
                        refreshing: false,
                        oldSearchKey: newSearchKey
                    });
                }
            }

        );
    }


    render() {
        let { loading,sortType,sortTypeEnum,dataSource,totalCount,height,hasMore } = this.state
        let { activity} = this.props;
        console.log("height:",height);

        return (
            <WagesCheckContainer>
                <div className="container">
                    {/*<PullToRefresh*/}
                    {/*    damping={60}*/}
                    {/*    style={{*/}
                    {/*        height: height,*/}
                    {/*        overflow: 'auto',*/}
                    {/*    }}*/}
                    {/*    direction={'up'}*/}
                    {/*    refreshing={this.state.refreshing}*/}
                    {/*    onRefresh={() => {*/}
                    {/*        console.log("PullToRefresh onRefresh")*/}
                    {/*        if(totalCount===0||totalCount>dataSource.length){*/}
                    {/*            this.setState({ refreshing: true });*/}
                    {/*            this.getCreationsData()*/}
                    {/*        }*/}

                    {/*    }}*/}
                    {/*>*/}
                    <img src={activity?.bgImgPath?.toImg()} style={{width: "100%"}} alt="" />
                    <div className="container2">
                        <Space block direction='vertical' >
                            <SearchBar
                                maxLength={255}
                                placeholder='请输入作品编号或作品标题'
                                value={this.state.newSearchKey}
                                onSearch={val => {
                                    this.setState({
                                        newSearchKey:val
                                    },() => this.getCreationsData());
                                }}
                                onChange={val => {
                                    this.setState({newSearchKey:val})
                                }}
                                onBlur={() => {
                                    this.initSearchData()
                                }}
                                style={{
                                    '--background': '#ffffff',
                                }}
                            />
                        </Space>
                        <Space block direction='vertical' >
                            <div className="text marginTop16">排序方式</div>
                        </Space>
                        <Space className="marginTop8">

                            <Button
                                color='primary'
                                size='small'
                                style={{
                                    "--border-radius":"8px"
                                }}
                                fill={sortType===sortTypeEnum.default?"solid":"outline"}
                                onClick={
                                    ()=>{
                                        this.setState({
                                            sortType:sortTypeEnum.default,
                                            page:1,
                                            dataSource:[]
                                        },() => this.getCreationsData())

                                    }
                                }
                            >默认</Button>
                            {activity.voteState&&<Button
                                color='primary'
                                size='small'
                                style={{
                                    "--border-radius":"8px"
                                }}
                                fill={sortType===sortTypeEnum.vote?"solid":"outline"}
                                onClick={
                                    ()=>{
                                        this.setState({
                                            sortType:sortTypeEnum.vote,
                                            page:1,
                                            dataSource:[]
                                        },() => this.getCreationsData())
                                    }
                                }
                            >投票数</Button>}

                            <Button
                                color='primary'
                                size='small'
                                style={{
                                    "--border-radius":"8px"
                                }}
                                fill={sortType===sortTypeEnum.time?"solid":"outline"}
                                onClick={
                                    ()=>{
                                        this.setState({
                                            sortType:sortTypeEnum.time,
                                            page:1,
                                            dataSource:[]
                                        },() => this.getCreationsData())
                                    }
                                }
                            >时间</Button>
                        </Space>

                        {
                            (dataSource.length ===0&&loading === false)?
                                <Empty description='暂无数据' />:
                                <>
                                    <List
                                        className="marginTop8"
                                        loading={loading}
                                        itemLayout="horizontal"
                                        grid={{ gutter: 16, column: 2 }}
                                        dataSource={dataSource}
                                        rowKey={(item) => item.id}
                                        renderItem={item => (
                                            <List.Item>
                                                <ImgVideoListItem item={item} history={this.props.history}/>
                                            </List.Item>
                                        )}
                                    />
                                    <InfiniteScroll loadMore={()=> {
                                        const that = this;
                                        setTimeout(() =>that.getCreationsData(),500)
                                        }
                                    } hasMore={hasMore} />
                                </>


                        }
                        <div style={{height:'50px',width:'100vw'}}></div>
                    </div>
                    {/*</PullToRefresh>*/}
                </div>
            </WagesCheckContainer>
        )
    }
}

const mapState = state => {

    return {
        userInfo:state.getIn(['user', 'userInfo']),
        activity:state.getIn(['activity', 'activitySelect'])
    }

}
const mapDispatch = dispatch => {
    return {

        _getUserInfoData(data) {

            dispatch(getUserInfoData(data))
        }
    }
}

export default connect(mapState, mapDispatch)(WagesHome)
